import React, {useState, useEffect} from 'react';
import {toJS} from 'mobx';

import {Button, List, Popconfirm} from 'antd';
import store from "./store";
import {observer} from 'mobx-react';

import styles from '../layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function (props) {
  const { t } = useTranslation();
  const {invoices} = store
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    invoices.length === 0 && store.fetchRecodes()
  }, [invoices.length])

  const onEdit = (index) => {
    store.index = index
    store.invoice = store.invoices[index]
    props.setVisible()
  }

  const setDefault = (index) => {
    setLoading(true)
    store.index = index
    store.setDefault().finally(() => {
      setLoading(false)
    })

  }

  return (
    <React.Fragment>
      <List
        header=''
        footer=''
        dataSource={toJS(invoices)}
        split={false}
        pagination={false}
        loading={store.isFetching}
        renderItem={(item, index) => (
          <List.Item>

            <div key={item.id} className={styles.item}>
              <div className={styles.hd}>
                {
                  item['is_default'] ? (
                    <Button style={{color: 'red'}} type='text'>{t('默认发票')}</Button>
                  ) : null
                }
                <div style={{flex: 1}}/>
              </div>

              <div className={[styles.bd, styles.labelW].join(" ")}>
                <div style={{width: '40%'}}>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('开票类型')}：</div>
                    <div className={styles.val}>增值税专用发票</div>
                  </div>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('纳税登记号')}：</div>
                    <div className={styles.val}>{item.tax_sn}</div>
                  </div>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('银行账号')}：</div>
                    <div className={styles.val}>{item['bank_number']}</div>
                  </div>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('开票联系电话')}：</div>
                    <div className={styles.val}>{item.phone}</div>
                  </div>

                </div>

                <div style={{width: '50%'}}>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('发票抬头')}：</div>
                    <div className={styles.val}>{item.title}</div>
                  </div>
                  <div className={styles.param}>
                    <div className={styles.label}>{t('开户银行')}：</div>
                    <div className={styles.val}>{item['bank_name']}</div>
                  </div>
                  <div className={styles.param}>
                    <div className={styles.label}>{t('开票通讯地址')}：</div>
                    <div className={styles.val}>{item.address}</div>
                  </div>

                </div>


              </div>
            </div>

          </List.Item>
        )}
      />
    </React.Fragment>
  )
})
